import axiosInstance from "../interceptor/instance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_USER}/template`;
const permBaseUrl = `${process.env.REACT_APP_BASE_URL_USER}/permission`;

export const getAllModels = async (params) => {
  const response = await axiosInstance.get(
    baseUrl,
    { params: params }
  );
  return response.data;
};

export const getPermission = async (data) => {
  const response = await axiosInstance.post(
    permBaseUrl,
    data
  );
  return response.data;
};

export const getAllRequests = async (params) => {
  const response = await axiosInstance.get(
    permBaseUrl,
    { params: params }
  );
  return response.data;
};
